export default __webpack_public_path__ + "static/media/confirmInvoice.d04dd3dd.svg";